// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__jdfzz","modalForm":"UpgradeEpcsModal_modalForm__q8os2","modalFooter":"UpgradeEpcsModal_modalFooter__3MtOQ"};